module.exports = __webpack_public_path__ + "img/park.69d71ffd.jpg";